import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MembersRoutingModule } from './members-routing.module';
import { MembersComponent } from './members/members.component';
import { SharedModule } from 'src/app/shared';
import { MembersService, ConfigService, Util } from 'src/app/core';

@NgModule({
  declarations: [MembersComponent],
  imports: [
    CommonModule,
    SharedModule,
    MembersRoutingModule
  ],
  providers:[
    MembersService,
    ConfigService,
    Util
  ]
})
export class MembersModule { }
